import SVGIconWrapper from "./SVGIconWrapper"

const IconCautionRecurring = (props) => (
    <SVGIconWrapper
        fill={props.fill ?? "#000000"}
        style={props.style}
        viewBox="7 0 56 56"
        iconClass={`icon--caution-recurring ${props.iconClass}`}
        wrapperClass={props.wrapperClass}
        onClick={props.onClick}
    >
        <g transform="translate(0,-952.36218)">
            {/* Smaller caution triangle */}
            <g transform="translate(35,980) scale(0.65)">
                {/* Simple exclamation point */}
                <rect x="-2.5" y="-22" width="5" height="32" fill={props.fill ?? "#000000"} rx="2.5"/>
                <circle cx="0" cy="16" r="3.5" fill={props.fill ?? "#000000"}/>
            </g>
            
            {/* Refresh arrows wrapping around the triangle */}
            <g transform="translate(35,980)">
                {/* Refresh arrow scaled and positioned to wrap around triangle */}
                <g transform="scale(3.0) translate(-12,-12)">
                    <path d="M4.06189 13C4.02104 12.6724 4 12.3387 4 12C4 7.58172 7.58172 4 12 4C14.5006 4 16.7332 5.14727 18.2002 6.94416M19.9381 11C19.979 11.3276 20 11.6613 20 12C20 16.4183 16.4183 20 12 20C9.61061 20 7.46589 18.9525 6 17.2916M9 17H6V17.2916M18.2002 4V6.94416M18.2002 6.94416V6.99993L15.2002 7M6 20V17.2916" stroke={props.fill ?? "#000000"} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
                </g>
            </g>
        </g>
    </SVGIconWrapper>
)

export default IconCautionRecurring